<template>
  <div>
    <Breadcrumb :options="breadcrumb" />

    <el-form ref="form" :model="form" :label-width="labelWidth">
      <el-form-item class="item" label="运单信息">
        <div class="orderlist" style="margin-top: 15px;">
          <div class="item" v-for="(c, i) in checkedLists" :key="'item' + i">
            <div class="row0">{{ c.order_num }}</div>
            <div class="row1" v-for="(p, i) in modalListProps" :key="'item' + i">
              <div class="col0">{{ p.label }}：</div>
              <div class="col1">{{ c[p.keyName] }}</div>
            </div>
            <div class="rowlast">
              <input type="number" placeholder="请填写补差金额" v-model="c.money" @change="onMoneyChange">
              <div class="unit">元</div>
            </div>
          </div>
        </div>
      </el-form-item>
      <FormItem v-for="(c, i) in formCtrl" :key="'formItem' + i" :viewMode="viewMode" :config="c" :options="c.options"
        :inputValue="form[c.keyName]" @onChange="onChange" />
    </el-form>

    <div class="btns">
      <SubmitBtn :editMode="mode === 'edit'" @onSubmit="onSubmit"></SubmitBtn>
      <el-button @click="cancel">取 消</el-button>
    </div>
  </div>
</template>

<script>
import detailMixin from "../../mixin/detail";

export default {
  mixins: [detailMixin],
  data() {
    return {
      baseUrl: 'compen',
      breadcrumb: [
        { name: "运单管理", path: `/order/makeup` },
        { name: "运单补差", path: `/order/makeup` },
        { name: "运单补差添加" },
      ],
      formCtrl: [
        {
          label: "备注",
          keyName: "content",
          err: "请填写备注信息",
          type: "textarea",
        },
      ],
      form: {
        iscustom: 1,
        iscar: 1,
      },
      checkedLists: [],
      modalListProps: [
        { keyName: "predict_loading_date", label: "装货日期", },
        { label: '车牌号', keyName: 'license' },
        { label: '客户名称', keyName: 'shname' },
        // { label: '装车公司', keyName: 'company' },
        { label: '装货地址', keyName: 'coaddress' },
        { label: '卸货地址', keyName: 'enaddress' },
        { label: '装货量', keyName: 'inton' },
        { label: '卸货量', keyName: 'unton' },
        { label: '公司运费', keyName: 'infreight' },
      ],
    };
  },
  methods: {
    setDetailOrderData({ data }) {
      if (data) {
        this.checkedLists = [data]
        this.form.money = data.money
        console.log({...data})
      }
    },
    onMoneyChange() {
      this.form.money = this.checkedLists[0].money
      console.log({ ...this.form })
    },
  },
  mounted() { },
};
</script>

<style lang="less" scoped>
/deep/ .el-form {
  background-color: #fff;
  padding-top: 20px;
  border-radius: 5px;
  box-shadow: 0px 0px 10px rgb(0 0 0 / 3%);

  .el-form-item {
    border-bottom: 1px solid #f2f6fc;
    padding: 0 20px 15px 0;

    .el-textarea__inner {
      width: 300px;
      height: 85px;
      font-family:"Microsoft Yahei";
    }
  }
}

.btns {
  margin: 40px 0 60px 180px;
}

.orderlist {
  display: flex;
  flex-wrap: wrap;

  .item {
    width: 352px;
    background: #F9FBFC;
    margin: 0 15px 15px 0;
    position: relative;
    // box-shadow: 0px 0px 8px rgb(0 0 0 / 10%);
    color: #000;
    font-size: 14px;
    padding: 15px;
    border-radius: 5px;
    border: 1px solid #EAF0FC;
    box-sizing: border-box;

    &:nth-child(3n) {
      margin-right: 0;
    }

    &.is-checked {
      // box-shadow: 0px 0px 8px #409EFF;
      border: 1px solid #2691FF;
      position: relative;

      /deep/.el-checkbox__label {
        color: #000;
      }

      &::after {
        content: '';
        position: absolute;
        right: 0;
        top: 0;
        width: 36px;
        height: 24px;
        background: url(../../../assets/img/icon_order_checked.png);
      }
    }

    /deep/ .el-checkbox__input {
      display: none;
    }

    /deep/ .el-checkbox__label {
      padding: 0;
      width: 100%;
    }

    .row0 {
      height: 21px;
      font-size: 16px;
      color: #303133;
      margin-bottom: 15px;
    }

    .row1 {
      width: 100%;
      display: flex;
      line-height: 19px;

      &:not(:last-of-type) {
        margin-bottom: 10px;
      }

      .col0 {
        width: 70px;
        text-align: right;
        font-size: 14px;
        line-height: 19px;
        color: #909399;
      }

      .col1 {
        flex: 1;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }

    .rowlast {
      display: flex;
      border-bottom: 1px solid #eee;
      padding: 0 15px;
      width: 322px;
      height: 43px;
      background: #F7F7F7;
      border-radius: 2px;
      border-bottom: 2px solid #2691FF;
      box-sizing: border-box;
      margin-top: 25px;

      input {
        flex: 1;
        background-color: transparent;
      }
    }
  }
}

.dialog {
  /deep/ .el-dialog {
    width: 1004px;
  }

  .searchForm {
    display: flex;
    flex-wrap: wrap;
    box-shadow: none;
    padding: 0;

    /deep/ .el-form-item {
      border: none;
      margin-right: 0;
    }
  }

  .modalForm {
    position: absolute;
    right: 20px;
    top: 84px;

    /deep/ .el-form-item {
      .el-form-item__content {
        .el-input {
          input {
            width: 170px;
            padding-right: 40px;
            background: #F2F6FC;
          }
        }

        .unit {
          position: absolute;
          right: 10px;
        }
      }
    }
  }

  .modal-scroll {
    /deep/ .el-scrollbar__wrap {
      overflow-x: hidden;
    }

    /deep/ .is-horizontal {
      display: none;
    }
  }

  .orderlist {

    .item {
      width: 310px;
    }
  }

  .btns {
    text-align: center;
    margin-left: 0;
  }
}
</style>
